export default __webpack_public_path__ + "static/inventory-optimisation-2--mobile-2589a669d01ea2c05ffcd27cca084f1e.webp";